import { render, staticRenderFns } from "./newdetail.vue?vue&type=template&id=33bd15d6&scoped=true&"
import script from "./newdetail.vue?vue&type=script&lang=js&"
export * from "./newdetail.vue?vue&type=script&lang=js&"
import style0 from "./newdetail.vue?vue&type=style&index=0&id=33bd15d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd15d6",
  null
  
)

export default component.exports